import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./hm-theme.css";

const UploadCompaniesCsvFile = ({ isOpen, onRequestClose }) => {
  const [loading, setLoading] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [sendNotification, setSendNotification] = useState(false);

  const url = "/api/companydetails/upload";
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!csvFile) {
      toast.error("Please select a CSV file to upload.");
      return;
    }

    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data"))?.token;

    const formData = new FormData();
    formData.append("file", csvFile);
    formData.append("sendNotification", sendNotification);

    try {
      await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      toast.success("CSV file uploaded successfully");
      onRequestClose();
      setCsvFile(null);
      setSendNotification(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleCsvFileChange = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);
  };

  const handleSendNotificationChange = (e) => {
    setSendNotification(e.target.checked);
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered className="hm-modal">
      <Modal.Header closeButton className="border-bottom-0 pb-0">
        <Modal.Title className="fw-bold d-flex align-items-center gap-2" style={{ color: "#1e293b", fontSize: "1.15rem" }}>
          <i className="material-icons text-primary">upload_file</i>
          Upload Company CSV
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3 pb-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="company-csv-file" className="form-label fw-semibold small text-secondary">
              Select CSV File
            </label>
            <div className="p-3 border border-2 border-dashed rounded-3 text-center bg-light position-relative">
              <i className="material-icons text-muted mb-1" style={{ fontSize: "32px" }}>cloud_upload</i>
              <p className="mb-1 small fw-semibold text-dark">
                {csvFile ? csvFile.name : "Click to choose CSV file"}
              </p>
              <span className="text-muted extra-small d-block mb-2">Supports .csv files only</span>
              <input
                id="company-csv-file"
                type="file"
                accept=".csv"
                className="form-control form-control-sm"
                onChange={handleCsvFileChange}
              />
            </div>
          </div>

          <div className="form-check form-switch mb-4">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="sendNotification"
              checked={sendNotification}
              onChange={handleSendNotificationChange}
            />
            <label className="form-check-label fw-semibold text-secondary small" htmlFor="sendNotification">
              Send email notifications to company admins
            </label>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-2 pt-2 border-top">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-pill px-4"
              onClick={onRequestClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-hm-primary"
              disabled={loading || !csvFile}
            >
              <i className="material-icons" style={{ fontSize: "1rem" }}>file_upload</i>
              Upload CSV
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default UploadCompaniesCsvFile;

